import * as React from 'react';
import { TreeView as MatTreeView, TreeViewProps as MatTreeViewProps } from '@mui/lab';
import { Icon } from '../Icon';

export type TreeViewProps = MatTreeViewProps;
type TreeViewPropsWithRef = TreeViewProps & React.RefAttributes<HTMLUListElement>;

const defaultProps = {
  defaultCollapseIcon: <Icon icon="ArrowDropDown" />,
  defaultExpandIcon: <Icon icon="ArrowRight" />
};

const TreeView: React.ForwardRefExoticComponent<TreeViewPropsWithRef> = React.forwardRef<HTMLUListElement, TreeViewProps>((props, ref) => {
  return <MatTreeView ref={ref} {...defaultProps} {...props} />;
});

TreeView.displayName = 'TreeView';

export { TreeView };
